// extracted by mini-css-extract-plugin
module.exports = {"languageMenu":"_bU","languageMenu__link":"_bV","active":"_bW","languageMenu__title":"_bX","languageMenu__name":"_bY","languageMenu__activeIcon":"_bZ"};